module.exports = __webpack_public_path__ + "static/media/trophy-1.9cc0b061.svg";